<template>
  <div>
    <v-row v-if="isRespondida && isCotacaoAberta">
      <v-col cols="12" class="text-right">
        <px-ajuda-icon :link="linkAjuda" btn-class=""/>
        <v-btn color="primary"
               link
               :to="`/cotacoes/${solicitacao.id}/responder`">
          <v-icon>mdi-pencil</v-icon>
          Alterar proposta
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center"
             class="headline mb-5"
             v-if="!solicitacao.respostaFrete">
        Ainda não há negociações
      </v-col>
    </v-row>
    <px-cotacao-frete-negociacao-mensagens class="mt-3"
                                           v-if="solicitacao.respostaFrete"
                                           :resposta="solicitacao.respostaFrete"
                                           :disabled="isFinalizada"/>
  </div>
</template>

<script>
import { alterarProposta } from '@/api/ajuda-mapper';
import { SituacaoCotacao, SituacaoSolicitacaoFrete } from 'px-business-components';
import CotacaoFreteNegociacaoMensagens from './CotacaoFreteNegociacaoMensagens.vue';

const ABERTAS = [SituacaoCotacao.keys.ABERTA.key,
  SituacaoCotacao.keys.CARRINHO.key,
  SituacaoCotacao.keys.COMPRA.key];

export default {
  props: {
    solicitacao: Object,
  },
  data() {
    return {
      linkAjuda: alterarProposta,
    };
  },
  computed: {
    isFinalizada() {
      return !this.isCotacaoAberta;
    },
    isRespondida() {
      return this.solicitacao.situacao
        === SituacaoSolicitacaoFrete.keys.RESPONDIDA.key;
    },
    isCotacaoAberta() {
      return ABERTAS.includes(this.solicitacao.cotacaoFrete.situacao);
    },
  },
  components: {
    pxCotacaoFreteNegociacaoMensagens: CotacaoFreteNegociacaoMensagens,
  },
};
</script>
